import {
  ForgotPassword,
  Login,
  ResetPassword,
  Signup,
  OtpVerification,
  DeleteAccount,
  DeleteAccountRequest,
} from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.LOGIN.path,
      name: "",
      key: routesMap.LOGIN.path,
      commonRoute: false,
      private: false,
      element: <Login />,
    },
    {
      path: routesMap.FORGOT_PASSWORD.path,
      name: "",
      key: routesMap.FORGOT_PASSWORD.path,
      commonRoute: false,
      private: false,
      element: <ForgotPassword />,
    },
    {
      path: routesMap.RESET_PASSWORD.path,
      name: "",
      key: routesMap.RESET_PASSWORD.path,
      commonRoute: false,
      private: true,
      element: <ResetPassword />,
    },
    {
      path: routesMap.SIGNUP.path,
      name: "",
      key: routesMap.SIGNUP.path,
      commonRoute: false,
      private: false,
      element: <Signup />,
    },
    {
      path: routesMap.OTP_VERIFICATION.path,
      name: "",
      key: routesMap.OTP_VERIFICATION.path,
      commonRoute: false,
      private: false,
      element: <OtpVerification />,
    },
    {
      path: routesMap.DELETE_ACCOUNT.path,
      name: "",
      key: routesMap.DELETE_ACCOUNT.path,
      commonRoute: false,
      private: false,
      element: <DeleteAccount />,
    },
    {
      path: routesMap.DELETE_ACCOUNT_REQUEST.path,
      name: "",
      key: routesMap.DELETE_ACCOUNT_REQUEST.path,
      commonRoute: false,
      private: false,
      element: <DeleteAccountRequest />,
    },
  ];
}
